import { getFormation } from '../utils/formations'

const POSITION_NUMBERS = {
  football: {
    1: 'Goalkeeper', 2: 'Right Corner Back', 3: 'Full Back', 4: 'Left Corner Back',
    5: 'Right Half Back', 6: 'Centre Back', 7: 'Left Half Back',
    8: 'Midfield', 9: 'Midfield', 10: 'Right Half Forward', 11: 'Centre Forward',
    12: 'Left Half Forward', 13: 'Right Corner Forward', 14: 'Full Forward', 15: 'Left Corner Forward'
  },
  hurling: {
    1: 'Goalkeeper', 2: 'Right Corner Back', 3: 'Full Back', 4: 'Left Corner Back',
    5: 'Right Half Back', 6: 'Centre Back', 7: 'Left Half Back',
    8: 'Midfield', 9: 'Midfield', 10: 'Right Half Forward', 11: 'Centre Forward',
    12: 'Left Half Forward', 13: 'Right Corner Forward', 14: 'Full Forward', 15: 'Left Corner Forward'
  }
}

export default function SquadTab({
  lineup, subs, substitutedOff, scorerTallies, fixture,
  isUnlimitedSubs, isFriendly, isRedCarded, isInSinBin, handlePlayerTap
}) {
  if (!fixture) return null
  const dynamicPositionNames = fixture.players_per_side ? getFormation(fixture.players_per_side).positionNames : null
  return (
    <div>
      <div style={{ padding: '8px 14px 4px', fontSize: '10px', color: '#888', letterSpacing: '0.3px' }}>STARTERS</div>
      {lineup.map(p => {
        const isRed = isRedCarded(p.id)
        const isSin = isInSinBin(p.id)
        const tally = scorerTallies[p.id]
        return (
          <div key={p.id} onClick={() => handlePlayerTap(p, false)}
            style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 14px', borderBottom: '0.5px solid #f0f0f0', cursor: 'pointer', background: isRed ? '#fff5f5' : isSin ? '#f5f5f0' : 'white' }}>
            <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: isRed ? '#A32D2D' : isSin ? '#444' : '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '500', color: isRed || isSin ? 'white' : '#185FA5', flexShrink: 0 }}>
              {isRed ? '🟥' : isSin ? '⬛' : (p.match_number || p.jersey_number || p.assigned_number || '—')}
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: '14px', color: '#333' }}>{p.full_name}</p>
              <p style={{ fontSize: '10px', color: '#888' }}>{(dynamicPositionNames || POSITION_NUMBERS[fixture.sport])?.[p.assigned_number] || ''}</p>
            </div>
            {tally && <span style={{ fontSize: '13px', fontWeight: '500', color: '#185FA5' }}>{tally.goals}-{String(tally.points).padStart(2, '00')}</span>}
          </div>
        )
      })}
      {subs.length > 0 && (
        <>
          <div style={{ padding: '8px 14px 4px', fontSize: '10px', color: '#888', letterSpacing: '0.3px' }}>SUBSTITUTES</div>
          {subs.map(p => {
            const wasOff = substitutedOff.find(x => x.id === p.id)
            const isRed = isRedCarded(p.id)
            const isSin = isInSinBin(p.id)
            const avail = (isUnlimitedSubs || isFriendly || !wasOff) && !isRed
            const tally = scorerTallies[p.id]
            return (
              <div key={p.id} onClick={() => avail && !isSin ? handlePlayerTap(p, true) : null}
                style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 14px', borderBottom: '0.5px solid #f0f0f0', cursor: avail ? 'pointer' : 'default', opacity: avail ? 1 : 0.4 }}>
                <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: isRed ? '#A32D2D' : isSin ? '#444' : '#EEEDFE', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '500', color: isRed || isSin ? 'white' : '#533AB7', flexShrink: 0 }}>
                  {isRed ? '🟥' : isSin ? '⬛' : (p.match_number || p.jersey_number || p.assigned_number || '—')}
                </div>
                <div style={{ flex: 1 }}>
                  <p style={{ fontSize: '14px', color: '#333' }}>{p.full_name}</p>
                  <p style={{ fontSize: '10px', color: '#888' }}>Sub{wasOff ? ' · subbed off' : ''}</p>
                </div>
                {tally && <span style={{ fontSize: '13px', fontWeight: '500', color: '#185FA5' }}>{tally.goals}-{String(tally.points).padStart(2, '00')}</span>}
              </div>
            )
          })}
        </>
      )}
    </div>
  )
}